<template>
  <div id="app">
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <div class="navbar-item">
          <h1 class="title is-4" style="color: white; margin: 0;">Remote Studio</h1>
        </div>

        <!-- 1. Added Burger Icon for Mobile -->
        <a 
          role="button" 
          class="navbar-burger" 
          :class="{ 'is-active': isMenuOpen }" 
          aria-label="menu" 
          aria-expanded="false"
          @click="isMenuOpen = !isMenuOpen"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <!-- 2. Added 'is-active' toggle for Mobile Menu -->
      <div class="navbar-menu" :class="{ 'is-active': isMenuOpen }">
        <div class="navbar-end">
          <!-- 3. Standard Navbar Links -->
          <router-link 
            v-for="item in navItems" 
            :key="item.path"
            :to="item.path" 
            class="navbar-item"
            :class="{ 'is-active': isActive(item.path) }"
            @click="isMenuOpen = false"
          >
            {{ item.name }}
            <span 
              v-if="item.name === 'Calls' && activeCallCount > 0" 
              class="tag is-danger is-rounded ml-2"
              style="font-size: 0.75rem; height: 1.5em; min-width: 1.5em;"
            >
              {{ activeCallCount }}
            </span>
    <span 
        v-if="item.name === 'Studio Connection'"
        class="tag is-rounded ml-2" 
        :class="sipStatus.callstatus === 2 ? 'has-background-success' : 'has-background-grey-light'"
        style="width: 10px; height: 10px; padding: 0; min-width: 10px;"
        title="Studio Connection Status"
      ></span>
          </router-link>
          <a class="navbar-item" @click="handleLogout">
            Logout
          </a>
        </div>
      </div>
    </nav>

    <div class="main-content">
      <router-view />
    </div>
  </div>

  <audio id="remoteAudio" autoplay></audio>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'; // Added ref
import { useRoute } from 'vue-router';
import { handleLogout as authLogout, authState } from '@/services/auth';
import { initWebRTC, webRTCService } from '@/services/connect';
import { initCallManager } from '@/services/callmanager';
import { initWebSocket, getStats } from '@/services/websocket';

const route = useRoute();
const isMenuOpen = ref(false); // Mobile menu state

const { activeCallCount } = getStats();

const sipStatus = webRTCService().sipStatus;

const allNavItems = [
  { name: 'Studio Connection', path: '/connect' },
  { name: 'Calls', path: '/calls' },
  { name: 'Admin', path: '/admin', requiresAdmin: true }
];

const navItems = computed(() => {
  return allNavItems.filter(item => {
    if (item.requiresAdmin) return authState.role === 'Admin';
    return true;
  });
});


const isActive = (path) => route.path === path;

const handleLogout = () => {
  isMenuOpen.value = false;
  authLogout();
};

onMounted(() => {
  initWebSocket().catch(err => console.error("WS Error:", err));
  initWebRTC(authState.sipUser, authState.sipToken).catch(err => console.error("WebRTC Error:", err));
  initCallManager().catch(err => console.error("CallMgr Error:", err));
});
</script>

<style>
/* Ensure the mobile menu looks good on small screens */
@media screen and (max-width: 1023px) {
  .navbar-menu {
    background-color: #363636; /* Match 'is-dark' background */
  }
  .navbar-item {
    color: white !important;
  }
  .is-fullwidth-mobile {
    width: 100%;
  }
}

/* Rest of your existing styles */
#app { font-family: Avenir, Helvetica, Arial, sans-serif; display: flex; flex-direction: column; }
.navbar { flex-shrink: 0; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); }
.main-content { flex: 1; display: flex; width: 100%; }
</style>
